import determineBondMaturityDateArr from "./determine_bond_maturity_dates";
import determineTotalInvestValue from "./determine_total_invest_value";

export const createInvestmentSummaryArr = (gameInvestments, investmentMasterArr, currentPriceArr, 
        startGameDate, currentGameDate) => {
     let summaryValueArr = [];
     for (let i=0; i<gameInvestments.length; i++){
            const investTranArr = gameInvestments[i].transactionArr;
            const investType = gameInvestments[i].investType;
            if (investType === "bond" && investTranArr.length > 0){
                gameInvestments[i].maturityDateArr = 
                    determineBondMaturityDateArr(gameInvestments[i].transactionArr,
                        investmentMasterArr, gameInvestments[i].maturityDateArr,
                        startGameDate, currentGameDate );
            }
            const totalInvestTypeValue = determineTotalInvestValue(investTranArr, investType,
                    currentPriceArr);
            summaryValueArr.push(totalInvestTypeValue);
        }
        let initialValue = 0;
        let currentValue = 0;
        for (let i=0; i<summaryValueArr.length; i++){
            initialValue += +summaryValueArr[i].initialValue;
            currentValue += +summaryValueArr[i].currentValue;
        }
        const summaryObj = {investType: "all", initialValue: initialValue, currentValue: currentValue};
        summaryValueArr.push(summaryObj);
        return summaryValueArr;
}
export default createInvestmentSummaryArr;